import { render, staticRenderFns } from "./InstrumentsSearch.vue?vue&type=template&id=3f3bfda6&"
import script from "./InstrumentsSearch.vue?vue&type=script&lang=ts&"
export * from "./InstrumentsSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports